module.exports = __webpack_public_path__ + "img/38_72.3d0a399f.png";